
import {
    addIndication,
    updateIndications,
    getIndications,
    getIndication,
    searchIndications,
    deleteIndication
} from '@/services/endpoints/indications'
import {deleteBmi} from "@/services/endpoints/medicalRecordBmi";
import {searchUrologyTest} from "@/services/endpoints/urologyTests";
import statuses from "@/constatnts/statuses";
import localForage from "localforage";

export default {
    async addIndication({ commit }, payload) {
        try {
            let res = await addIndication(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getIndications({ commit },payload) {
        try {
            let res = await getIndications(payload);
            if(res) {
                res.data.data.forEach((s,index) => {
                    s.id = index
                });

                 commit('SET_INDICATIONS', {indications :res.data.data})
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },

    async deleteIndication({commit}, payload) {
        try {
            let res = await deleteIndication(payload.indicationId);
            if (res) {
                return res.data
            } else {
                throw {}
            }
        } catch (err) {
            throw err
        }
    },

    async updateIndications({commit},payload) {
        try {
            let res = await updateIndications(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchIndications({ commit }, payload) {
        try {
            let res = await searchIndications(payload);
            if(res) {
                commit('SET_INDICATIONS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getIndicationToEdit({ commit }, indicationsId) {
        try {
            let res = await getIndication(indicationsId);
            if(res) {
                commit('SET_INDICATIONS_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },

    async getActiveIndications({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('indications-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {
                    let res = await searchIndications({status: statuses.ACTIVE});
                    if(res) {
                        commit('SET_INDICATIONS', {version: version, indications: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('indications');
                    if(!items){
                        let res = await searchIndications({status: statuses.ACTIVE});
                        if(res) {
                            commit('SET_INDICATIONS', {version: version, indications: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_INDICATIONS',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchIndications({status: statuses.ACTIVE});
                if (res) {
                    commit('SET_INDICATIONS', {version: version, indications: res.data.data});
                    return res.data.data
                }
            }

        }
        catch (err) {
            throw new Error(err)
        }
    },

}